export * from './atoms';
export * from './molecules';
export * from './organisms';

import { CatalogLayoutAtoms } from './atoms';
import { CatalogLayoutMolecules } from './molecules';
import { CatalogLayoutOrganisms } from './organisms';

export const LayoutComponents = [      
    ...CatalogLayoutAtoms,
    ...CatalogLayoutMolecules,
    ...CatalogLayoutOrganisms
]